module.exports = __webpack_public_path__ + "img/sidebar-home-ico-blue-01.1305d7a1.svg";